import React from 'react';
import type { CheckboxOptionType } from 'antd/lib/checkbox/Group';
import styled from '@emotion/styled';
import ControlledRadioButtons from 'components/common/form-controlled/controlled-radio-buttons';
import type { UseFormReturnType } from 'hooks/use-form.hook';
import type { VcsModalFormValues } from './access-card/use-connection-modal-access-card-form.hook';

export type BlockRadioButtonProps = {
  options: Array<CheckboxOptionType | string | number>;
  form: UseFormReturnType<VcsModalFormValues>;
};

export const VcsConnectionModalFormAuthenticationTypeButton = ({ options, form }: BlockRadioButtonProps) => (
  <Container>
    <ControlledRadioButtons
      label={{ id: 'templates.add.new.field.authorize.type' }}
      name={'authenticationType'}
      form={form}
      block
      options={options}
      optionType={'button'}
      buttonStyle={'solid'}
    />
  </Container>
);

const Container = styled.div`
  && .ant-radio-button-wrapper-checked {
    border: 1px solid #00d0a2;
    color: #00d0a2;
    background-color: white;
  }
`;
